
import { Component, Injector, OnInit } from '@angular/core';
import {
    ComponentContextService, DataFormBase,
    DateTimeControlSchema, EmailValidator, EventData, FormSchemaBase,


    OrganizationService,
    RadioButtonListControlSchema,
    SameValueValidator,
    TextControlSchema,
    UserPickerControlSchema,
    UserV5Service
} from 'tnx-shared';

@Component({
    selector: 'user-form',
    templateUrl: './user-form.component.html',
    styleUrls: ['./user-form.component.scss'],
    providers: [ComponentContextService],
})
export class UserFormComponent extends DataFormBase implements OnInit {

    constructor(
        protected _injector: Injector,
        protected _userV5Service: UserV5Service,
        private _organizationService: OrganizationService
    ) {
        super(_injector);
    }

    ngOnInit() {
        super.ngOnInit();


        this.setting.baseService = this._userV5Service;

        this.setting.schema = <FormSchemaBase[]>[
            new TextControlSchema({
                field: 'userName',
                label: 'Tên đăng nhập',
                required: true
            }),
            new TextControlSchema({
                field: 'email',
                label: 'Email',
                validators: [new EmailValidator()],
                required: true
            }),
            new TextControlSchema({
                field: 'firstName',
                label: 'Họ và tên đệm'
            }),
            new TextControlSchema({
                field: 'lastName',
                label: 'Tên',
                required: true
            }),
            new TextControlSchema({
                field: 'passwordHash',
                label: 'Mật khẩu',
                dataFormat: 'password',
                hidden: this.model.data.id ? true : false,
                required: true
            }),
            new TextControlSchema({
                field: 'confirmPassword',
                label: 'Gõ lại Mật khẩu',
                dataFormat: 'password',
                hidden: this.model.data.id ? true : false,
                required: true,
                validators: [new SameValueValidator(['passwordHash'], 'Mật khẩu phải giống nhau')]
            }),
            new DateTimeControlSchema({
                field: 'dob',
                label: 'Ngày sinh'
            }),
            new RadioButtonListControlSchema({
                field: 'gender',
                label: 'Giới tính',
                displayField: 'label',
                valueField: 'value',
                dataSource: [{
                    label: 'Nam',
                    value: 1
                }, {
                    label: 'Nữ',
                    value: 0
                }, {
                    label: 'Không xác định',
                    value: null
                }]
            }),
            new TextControlSchema({
                field: 'phoneNumber',
                label: 'Điện thoại',
                dataFormat: 'phone'
            }),
            new TextControlSchema({
                field: 'address',
                label: 'Địa chỉ'
            }),
            new UserPickerControlSchema({
                field: 'directManagers',
                label: 'Người quản lý',
                multiple: true
            }),
        ];
    }

    async onFormInitialized(constrols: EventData) {
        // tiền xử lý dữ liệu (ví dụ tổng hợp datasource), trước khi gọi api get detail
        if (this.model.data.id) {

        } else {
            constrols.formControls['passwordHash'].hidden = false;
        }
    }

    async modifyDetailData(data) {
        data.confirmPassword = data.passwordHash;
        // xử lý dữ liệu lấy từ get detail về
    }

    onBeforeSave() {
        // trước khi lưu
    }
}



